module.exports = __webpack_public_path__ + "static/img/icon_search@2x.a7d7559d.png";